import React from 'react';
import PropTypes from 'prop-types';
import useScript from './useScript.js';

var Notification = function Notification(props) {
  var token = props.token,
    xChannel = props.xChannel,
    xApp = props.xApp,
    url = props.url,
    className = props.className;
  useScript(url);
  return /*#__PURE__*/React.createElement("div", {
    id: "notificationWidget",
    "x-app": xApp,
    "x-channel": xChannel,
    token: token,
    style: {
      paddingTop: 6
    },
    className: className
  });
};
Notification.defaultProps = {
  xChannel: 'NA',
  className: ''
};
Notification.propTypes = {
  token: PropTypes.string.isRequired,
  xChannel: PropTypes.string,
  xApp: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string
};

export { Notification as default };
